import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { authActionCreators } from '..';
import { showFailedRequestDialog } from '../../sagaUtils';
import * as api from '../authApi';

function* fetchPermissions(action: ReturnType<typeof authActionCreators.fetchPermissions>) {
  const response = yield* call(api.FetchPermissions);

  if (action.payload.removeItOverrides) {
    yield put(authActionCreators.resetItOverides());
  }

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(authActionCreators.setPermissions(response.value));
  }
}

export function* watchFetchPermissions() {
  yield takeEvery(authActionCreators.fetchPermissions.match, fetchPermissions);
}
